import React, {PureComponent, ReactNode} from 'react';
import ImageRu from 'images/registration/registration_ru.jpg';
import ImageEn from 'images/registration/registration_en.jpg';
import {getLanguageStorage} from 'app/utils/Language';

interface PropsInterface {
    headerLogin?: boolean
    headerImage?: boolean
}

export default class FastRegistrationHeader extends PureComponent<PropsInterface> {
    render(): ReactNode {
        const {headerLogin, headerImage} = this.props;

        return <div className={`popup-header-box${headerLogin ? ' login' : ''}`}>
            <span className="logo-span"/>
            {headerImage &&
                <span
                    className="popup-header-image"
                    style={{
                        backgroundImage: `url(${getLanguageStorage() === 'ru' ? ImageRu : ImageEn})`
                    }}
                />
            }
        </div>;
    }
}
